import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  FunctionField,
  EditButton,
  ShowButton,
  DeleteButton,
} from "react-admin";
import { Chip } from "@mui/material";

export const OAuthClientList = () => (
  <List>
    <Datagrid rowClick="show">
      <TextField source="clientId" label="Client ID" />
      <TextField source="name" label="Name" />
      <FunctionField
        label="Redirect URIs"
        render={(record: any) => {
          // Handle both array and PostgreSQL string format
          let uris = record.redirectUris;
          if (typeof uris === "string") {
            // Parse PostgreSQL array string: {uri1,uri2} -> ["uri1", "uri2"]
            uris = uris.replace(/[{}]/g, "").split(",");
          }
          if (!Array.isArray(uris)) return null;

          return uris
            .slice(0, 2)
            .map((uri: string, i: number) => (
              <Chip key={i} label={uri} size="small" sx={{ mr: 0.5 }} />
            ));
        }}
      />
      <BooleanField source="isActive" label="Active" />
      <DateField
        source="createdAt"
        label="Created"
        showTime
        options={{
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }}
      />
      <EditButton />
      <ShowButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
